import { useCallback } from 'react';

import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';

export const useIOSLiveActivities = () => {
  const startActivityFn = useCallback(
    (serverOrder: IServerOrder | IHistoricalOrder, showImHere: boolean) => {},
    []
  );

  const updateActivityFn = useCallback((orderId: String, statusUpdate: String) => {}, []);

  return {
    startActivity: startActivityFn,
    updateActivity: updateActivityFn,
  };
};
